/**
 * More Details Promo Bar
 * @param {object} opts
 */
import Flickity from 'flickity';

function moreDetailsPromoBar(opts) {
  const config = {
    dom: {
      header: 'header',
      headerContainer: 'header__container',
      main: 'main',
      nav: 'navigation',
      search: 'searchNavigation',
      promoBar: 'promoBar',
      trigger: 'js-more-details-trigger',
      content: 'js-more-details-content',
      carousel: 'js-promo-bar-carousel',
      carouselControls: 'promo-bar__carousel-controls',
      playBtnToggle: 'promo-bar__carousel-control-play--toggle'
    },
    cls: {
      active: 'is-active',
      open: 'is-open',
      hasPromoBar: 'has-more-details-promo-bar',
      headerPromo: 'header--promo-bar',
      navPromo: 'navigation--more-details-promo-bar',
      mainPromo: 'page-wrap--more-details-promo-bar',
      hide: 'hide'
    },
  };

  const c = __.extend(config, opts);
  const $header = document.getElementById(c.dom.header);
  const $main = document.getElementById(c.dom.main);
  const $nav = document.getElementById(c.dom.nav);
  const $promoBar = document.getElementById(c.dom.promoBar);
  const $triggers = $promoBar ? $promoBar.querySelectorAll(`.${c.dom.trigger}`) : [];
  let view;

  /**
   * Init
   */
  function init() {
    if (!$header || !$promoBar || !$nav || !$main) return;

    bindEvents();
    responsive();
    __.windowResize(responsive);
  }

  /**
   * Bind Events
   */
  function bindEvents() {
    if ($triggers.length === 0) return;

    $triggers.forEach(($trigger) => {
      $trigger.addEventListener('click', handleToggle);
    });

    // Close content when the page is scrolled
    __.addEvent({
      id: document,
      event: 'scroll',
      fn: () => {
        const $activeTrigger = document.querySelector(`.${c.dom.trigger}.${c.cls.active}`);
        if ($activeTrigger) {
          const contentId = $activeTrigger.getAttribute('aria-controls');
          const $content = document.getElementById(contentId);
          if ($content) {
            closeContent($activeTrigger, $content).then(() => {
              handleHeaderVisibility();
            });
          }
        }
      }
    });
  }

  /**
   * Handle Toggle
   */
  function handleToggle(e) {
    e.preventDefault();
    const $trigger = e.currentTarget;
    // disable the trigger button
    $triggers.forEach(($trigger) => {
      $trigger.disabled = true;
    });
    const contentId = $trigger.getAttribute('aria-controls');
    const $content = document.getElementById(contentId);

    if (!$content) return;

    const isActive = __.hasClass($trigger, c.cls.active);
    const isOpen = __.hasClass($content, c.cls.open);

    const handleContent = () => {
      // enable the trigger button
      $triggers.forEach(($trigger) => {
        $trigger.disabled = false;
      });
    };
    if (isActive && isOpen) {
      closeContent($trigger, $content).then(handleContent);
    } else {
      openContent($trigger, $content).then(handleContent);
    }
  }

  /**
   * Get Carousel Instance
   */
  function getCarouselInstance() {
    const $carousel = $promoBar ? $promoBar.querySelector(`.${c.dom.carousel}`) : null;
    if (!$carousel) return null;
    return Flickity.data($carousel);
  }

  /**
   * Get Play Button
   */
  function getPlayButton() {
    return $promoBar ? $promoBar.querySelector(`.${c.dom.playBtnToggle}`) : null;
  }

  /**
   * Open Content
   */
  function openContent($trigger, $content) {
    if(!__.hasClass($trigger, c.cls.active)) {
      __.addClass($trigger, c.cls.active);
    }
    if(!__.hasClass($content, c.cls.open)) {
      __.addClass($content, c.cls.open);
    }
    $trigger.setAttribute('aria-expanded', 'true');
    $content.setAttribute('aria-hidden', 'false');
    handleHeaderVisibility();
    
    // Pause carousel when opening
    const flkty = getCarouselInstance();
    const $playBtn = getPlayButton();
    if (flkty && flkty.player) {
      flkty.stopPlayer();
      __.removeClass($playBtn, 'playing');
      $playBtn.style.display = 'none';
    }
    
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, 400); // 400ms is the transition duration of the trigger
    });
  }

  /**
   * Close Content
   */
  function closeContent($trigger, $content) {
    if(__.hasClass($trigger, c.cls.active)) {
      __.removeClass($trigger, c.cls.active);
    }
    if(__.hasClass($content, c.cls.open)) {
      __.removeClass($content, c.cls.open);
    }
    __.removeClass($content, c.cls.open);
    $trigger.setAttribute('aria-expanded', 'false');
    $content.setAttribute('aria-hidden', 'true');
    
    // Resume carousel when closing (only if no other accordion is open)
    const $activeTrigger = document.querySelector(`.${c.dom.trigger}.${c.cls.active}`);
    if (!$activeTrigger) {
      const flkty = getCarouselInstance();
      const $playBtn = getPlayButton();
      if (flkty && flkty.player) {
        flkty.playPlayer();
        __.addClass($playBtn, 'playing');
        $playBtn.style.display = 'block';
      }
    }

    return new Promise((resolve) => {
      setTimeout(() => {
        handleHeaderVisibility();
        resolve();
      }, 400); // 400ms is the transition duration of the content
    });
  }

  /**
   * Responsive
   */
  function responsive() {
    __.mq({
      view: 'desktop',
      callback: () => {
        if (view === 'desktop') return;
        view = 'desktop';
        handleHeaderVisibility();
      },
    });

    __.mq({
      view: 'mobile',
      callback: () => {
        if (view === 'mobile') return;
        view = 'mobile';
        handleHeaderVisibility();
      },
    });
  }

  /**
   * Toggle Header Visibility
   */
  function handleHeaderVisibility() {
    const $headerContainer = $header.querySelector(`.${c.dom.headerContainer}`);
    const $activeTrigger = document.querySelector(`.${c.dom.trigger}.${c.cls.active}`);
    if (!$headerContainer) return;

    if ($activeTrigger) {
      __.addClass($headerContainer, c.cls.hide);
    } else {
      __.removeClass($headerContainer, c.cls.hide);
    }
    moveMoreDetailsContentToCarousel();
  }

  /**
   * Moves the more details content to js-promo-bar-carousel
   */
  function moveMoreDetailsContentToCarousel() {
    setTimeout(() => {
      const $moreDetailsContent = $promoBar.querySelector(`.${c.dom.content}`);
      if ($moreDetailsContent) {
        const $promoBarCarousel = $promoBar.querySelector(`.${c.dom.carousel}`);
        if ($promoBarCarousel) {
          $promoBarCarousel.appendChild($moreDetailsContent);
          $moreDetailsContent.removeAttribute('style');
          const flkty = getCarouselInstance();
          flkty.reloadCells();
        }
      }
    }, 100);
  }

  return init();
}

export default moreDetailsPromoBar;
